import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales December 2025 Data
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13) retroactive to 1/1/2025
const jobData = [
  {
    jobInfo: "E-761: Solution Based Property Management",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 6300.00,
    grossMarginPct: 0.4005,
    grossProfit: 2523.15,
    commissionPercentage: 0,
    salesCommission: 0, // Will be calculated
    salesManagerFee: 0,
    companyOH: 6300.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-736: John Tabor Horowitz Project",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 13354.50,
    grossMarginPct: 0.4933,
    grossProfit: 6587.77,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 13354.50 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-738: Aion Management Mariners Pointe PO #139484",
    leadSource: "Referral- Dominic's network",
    trade: "Siding",
    contractTotal: 20173.00,
    grossMarginPct: 0.3000,
    grossProfit: 6051.90,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 20173.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-734: Aion Management Mariners Pointe",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 1990.00,
    grossMarginPct: 0.3000,
    grossProfit: 597.00,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 1990.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-749: Ted Criswell",
    leadSource: "Referral- Dustin's Network",
    trade: "Siding",
    contractTotal: 21460.00,
    grossMarginPct: 0.4542,
    grossProfit: 9747.13,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 21460.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-754: Jim Alvarez",
    leadSource: "Previous Customer",
    trade: "Siding",
    contractTotal: 18280.00,
    grossMarginPct: 0.4371,
    grossProfit: 7990.19,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 18280.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-762: Tabor Design Build Enright Project",
    leadSource: "Referral- Cody's network",
    trade: "Siding",
    contractTotal: 32949.00,
    grossMarginPct: 0.5935,
    grossProfit: 19555.23,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 32949.00 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-767: Vicki and Jason Burns",
    leadSource: "Referral- Cody's network",
    trade: "Roofing",
    contractTotal: 36942.27,
    grossMarginPct: 0.4245,
    grossProfit: 15681.99,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 36942.27 * 0.13, // 13% flat rate
    netProfit: 0
  },
  {
    jobInfo: "E-741: North Green Condominium Association",
    leadSource: "Referral- Dominic's network",
    trade: "Roofing",
    contractTotal: 254699.00,
    grossMarginPct: 0.4006,
    grossProfit: 102032.42,
    commissionPercentage: 0,
    salesCommission: 0,
    salesManagerFee: 0,
    companyOH: 254699.00 * 0.13, // 13% flat rate
    netProfit: 0
  }
];

// Apply Cody Cline calculation formula
// For Cody reports: Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesDecemberData: ReportData = {
  kpis: {
    adSpend: 0, // No ad spend for Cody direct sales
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0, // No manager fees in Cody structure
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Referral- Dustin's Network", spend: 0 },
    { source: "Previous Customer", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 12,
    year: 2025
  }
};
